module.exports = __webpack_public_path__ + "img/emptyround.b00485e1.svg";